(function() {
    angular
        .module("app")
        .controller("MessageCreateController", MessageCreateController)

    MessageCreateController.$inject = [
        "$rootScope",
        "$scope",
        "$timeout",
        "$uibModal",
        "$uibModalInstance",
        "userMessagingService",
        "messagesService",
        "messageBoardsService",
        "messageBoard",
        "messageBoardIDs"
    ]

    function MessageCreateController(
        $rootScope,
        $scope,
        $timeout,
        $uibModal,
        $uibModalInstance,
        userMessagingService,
        messagesService,
        messageBoardsService,
        messageBoard,
        messageBoardIDs
    ){

        // Bug Fix for iPhones
        // Add position: fixed to <body> to prevent background scrolling
        document.body.classList.add("lockBackground")

        $scope.loadingModal = true
        $scope.loadedModal  = { visibility: "hidden" }

        $scope.messageBoard    = messageBoard
        $scope.messageBoardIDs = messageBoardIDs

        $scope.isBroadcast = $scope.messageBoard === undefined && $scope.messageBoardIDs.length > 0

        $scope.messageNumber  = 1
        $scope.messageName    = "C001"
        $scope.messageNumbers = []
        $scope.isOverwrite    = false

        $scope.showConfirmOverwrite = false
        $scope.showConfirmCancel    = false

        $scope.textMessageFormData = {}

        $scope.global_color_title = "Amber"

        $scope.global_style = {
            font:               "[fo1]",
            alignment:          "[jl3]",
            vertical_alignment: "[jp3]"
        }

        $scope.lineTemplate = {
            font:      "[fo1]",
            alignment: "[jl3]",
            text:      ""
        }

        if (!$scope.isBroadcast && $scope.messageBoard.meta.supportsMultipleColors) {
            $scope.global_style.color      = "[cf9]"
            $scope.lineTemplate.foreground = "[cf9]"
        }

        $scope.pageCounter = 0

        $scope.pages = []

        $scope.maxCharactersPerLine = 10

        let extraCharacterCustomers = [
            "J-Tech",
            "Allan Myers",
            "IEW",
            "MorganRail Inc.",
            "Lane Construction"
        ]

        if (extraCharacterCustomers.indexOf($rootScope.user.customer_name) !== -1) {
            // Temporary Allow J-Tech to create messages w/ 15 characters per line
            // for use with 3x7 font
            $scope.maxCharactersPerLine = 15
        }

        const isReady = []

        const onReady = () => {
            if (isReady.indexOf(false) >= 0) {
                isReady[isReady.indexOf(false)] = true
            }

            if (isReady.indexOf(false) < 0) {
                if ($scope.isBroadcast)
                    gtag("event", "broadcast_message", { action: "begin", message_board_ids: $scope.messageBoardIDs })
                else
                    gtag("event", "create_message", { action: "begin", device_id: $scope.messageBoard.device.id, type: "TEXT" })

                $scope.loadingModal = false
                $scope.loadedModal  = { visibility: "visible" }
            }
        }

        if($scope.isBroadcast) {

            onReady()

        } else {

            isReady.push(false)
            messageBoardsService.getMessageNumbers($scope.messageBoard.id, (data) => {

                $scope.messageNumbers = []

                for (const n of data.existing) {
                    $scope.messageNumbers.push({
                        number: n,
                        name:   $rootScope.generateMessageID("C", n),
                        exists: true
                    })
                }

                for (const n of data.available) {
                    $scope.messageNumbers.push({
                        number: n,
                        name:   $rootScope.generateMessageID("C", n),
                        exists: false
                    })
                }

                if(data.available.length > 0) {
                    $scope.messageNumber = data.available[0]
                    $scope.isOverwrite = false
                } else {
                    $scope.messageNumber = data.existing[0]
                    $scope.isOverwrite = true
                }

                $scope.messageName   = $rootScope.generateMessageID("C", $scope.messageNumber)

                onReady()

            })

            if ($scope.messageBoard.meta.isMatrixBoard) {

                isReady.push(false)
                messageBoardsService.getMessageBoardFonts($scope.messageBoard.id, (data) => {
                    $scope.messageBoardFonts = data
                    onReady()
                })
            }
        }

        $scope.setMessageNumber = (messageSlot) => {

            if (messageSlot.exists) {
                $scope.isOverwrite = true
            } else {
                $scope.isOverwrite = false
            }

            $scope.messageNumber = messageSlot.number
            $scope.messageName   = $rootScope.generateMessageID("C", $scope.messageNumber)

        }

        $scope.cancel = (force) => {

            if (!force) {

                if ($scope.showConfirmCancel) {
                    return
                }

                for (const page of $scope.pages) {
                    for (const line of page.lines) {
                        if (line.text !== "") {
                            $scope.showConfirmCancel = true
                            return
                        }
                    }
                }
            }

            if ($scope.isBroadcast)
                gtag("event", "broadcast_message", { action: "cancel", message_board_ids: $scope.messageBoardIDs })
            else
                gtag("event", "create_message", { action: "cancel", device_id: $scope.messageBoard.device.id, type: "TEXT" })

            // Bug Fix:
            // Remove position: fixed from <body> to restore scrolling
            document.body.classList.remove("lockBackground")

            // $uibModalInstance.close()
            // changed this so the .then() never fires on message-board.controller for in_process
            $uibModalInstance.dismiss("cancel")


        }

        $scope.resume = () => {
            $scope.showConfirmCancel = false
        }

        $scope.cancelOverwrite = () => {
            $scope.activate = false
            $scope.showConfirmOverwrite = false
        }

        $scope.broadcastMessage = () => {

            $scope.messageNumber = 1 // API makes it V001

            messagesService.createMessageData($scope.messageNumber, messagesService.extractMessageData($scope.pages), $scope.pageCounter)
            $scope.messageData = messagesService.getMessageData()

            messagesService.broadcastMessage(
                $scope.messageBoardIDs,
                $scope.messageData,

                () => {
                    //Success
                    gtag("event", "broadcast_message", { action: "complete", message_board_ids: $scope.messageBoardIDs })
                    $scope.working = false
                    $uibModalInstance.close()
                    userMessagingService.success("Message Broadcast Request Sent")
                },

                (error) => {
                    //Failure
                    $scope.working = false
                    $uibModalInstance.dismiss("cancel")
                    userMessagingService.error("Message Broadcast Failed: " + error)
                }
            )
        }

        $scope.createNewMessage = (activate, force) => {

            messagesService.createMessageData($scope.messageNumber, messagesService.extractMessageData($scope.pages), $scope.pageCounter)
            $scope.messageData = messagesService.getMessageData()

            if (!force && $scope.isOverwrite) {

                $scope.showConfirmOverwrite = true
                $scope.activate = activate

            } else {

                $scope.working = true
                $scope.showConfirmOverwrite = false

                if (force) {
                    $scope.messageData.message.activate = $scope.activate
                } else {
                    $scope.messageData.message.activate = activate
                }

                messagesService.createMessage(
                    $scope.messageBoard.id,
                    $scope.messageData,

                    () => {
                        //Success
                        gtag("event", "create_message", { action: "complete", device_id: $scope.messageBoard.device.id, slot: $scope.messageNumber, type: "TEXT" })
                        if ($scope.messageData.message.activate) gtag("event", "display_change", { action: "complete", device_id: $scope.messageBoard.device.id, slot_name: $scope.messageName })

                        $scope.working = false
                        $uibModalInstance.close()
                        userMessagingService.success("Message Creation Request Sent")
                    },

                    (error) => {
                        //Failure
                        $scope.working = false
                        $uibModalInstance.dismiss("cancel")
                        userMessagingService.error("Message Creation Failed: " + error)
                    }
                )
            }
        }

        $scope.setGlobalFont = function() {
            this.setGlobalLineAttribute("font", $scope.global_style.font)
        }

        $scope.setGlobalColor = function(colorCode, globalColorTitle) {
            $scope.global_style.color = colorCode
            $scope.global_color_title = globalColorTitle

            this.setGlobalLineAttribute("foreground", colorCode)
        }

        $scope.setGlobalAlignment = function(alignment) {
            this.setGlobalLineAttribute("alignment", alignment)
            $scope.global_style.alignment = alignment
        }

        $scope.setGlobalVerticalAlignment = function(verticalAlignment) {
            this.setGlobalPageAttribute("vertical_alignment", verticalAlignment)
            $scope.global_style.vertical_alignment = verticalAlignment
        }

        $scope.setGlobalLineAttribute = function(field, attribute) {
            $scope.lineTemplate[field] = attribute

            for (const page of $scope.pages) {
                for (const line of page.lines) {
                    if (line.hasOwnProperty(field)) {
                        line[field] = attribute
                    }
                }
            }
        }

        $scope.setGlobalPageAttribute = function(field, attribute) {
            for (const page of $scope.pages) {
                if (page.hasOwnProperty(field)) {
                    page[field] = attribute
                }
            }
        }

        $scope.getLineTemplate = function() {
            return JSON.parse(JSON.stringify($scope.lineTemplate))
        }

        $scope.addPage = function() {
            $scope.pageTemplate = {
                id: "page-" + $scope.pageCounter
            }

            $scope.pageCounter += 1

            var lines = []

            lines.push($scope.getLineTemplate())
            lines.push($scope.getLineTemplate())
            lines.push($scope.getLineTemplate())

            if (!$scope.isBroadcast && $scope.messageBoard.meta.supportsGraphicMessages) {
                lines.push($scope.getLineTemplate())
            }

            $scope.pages.push({
                vertical_alignment: $scope.global_style.vertical_alignment,
                lines: lines
            })
        }
        $scope.addPage()

        $scope.preview = () => {

            $scope.working = true

            $timeout(() => {

                messagesService.createMessageData($scope.messageNumber, messagesService.extractMessageData($scope.pages), $scope.pageCounter)
                $scope.messageData = messagesService.getMessageData()

                messagesService.previewMessage(
                    $scope.messageBoardIDs[0],
                    $scope.messageData,

                    (data) => {
                        //Success
                        $scope.working = false
                        $scope.preview_image = data

                        $uibModal.open({
                            templateUrl: "app/modals/preview-message.view.html",
                            controller: "PreviewMessageModalController",
                            windowClass: "previewMessageModal",
                            size: "lg",
                            resolve: {
                                previewImage: () => {
                                    return $scope.preview_image
                                }
                            }
                        }).result.catch((res) => {
                            if (!(res === "cancel" || res === "escape key press")) {
                                throw res
                            }
                        })
                    },

                    () => {
                        //Failure
                        $scope.working = false
                    }
                )
            }, 100)
        }

        $scope.openDeletePageModal = function(pageNumber) {
            var modalInstance = $uibModal.open({
                templateUrl: "app/modals/delete-page-modal.view.html",
                controller: "DeletePageModalController",
                windowClass: "deletePageModal",
                resolve: {
                    pageNumber: function() {
                        return pageNumber
                    }
                }
            })

            modalInstance.result.then(function() {
                delete $scope.textMessageFormData[pageNumber]
                $scope.pages.splice(pageNumber, 1)
                $scope.pageCounter -= 1
            }, function(res) {
                if (!(res === "cancel" || res === "escape key press")) {
                    throw res
                }
            })

        }
    }
})()
